import dashboard from '../../api/dashboard'

const state = {
  viewList: [],
  allRemain: null,
  monthCount: null,
  loading: true,
  username: ''
};

const actions = {
  // 获取总览数据
  async getOverview ({ commit }, payload) {
    const response = await dashboard.getOverview(payload);
    if (response.status === 200) {
      const { data } = response;
      localStorage.setItem('pieDate', JSON.stringify(data));
      commit('UPDATE_VIEWLIST', {
        overView: data.data.overView,
        allRemain: data.data.allRemain
      });
      commit('UPDATE_LOADING', {
        loading: false
      });
    }
  }
};
const mutations = {
  'UPDATE_VIEWLIST': (state, payload) => {
    state.username = JSON.parse(localStorage.getItem('accountInfo')).username;
    state.viewList = payload.overView;
    state.allRemain = payload.allRemain;
    state.monthCount = 0;
    payload.overView.forEach(ele => {
      state.monthCount += ele.count
    });
  },
  'UPDATE_LOADING': (state, payload) => {
    state.loading = payload.loading;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js